<template>
  <div>
    <main>
      <section>
        <div class="container">
          <div class="row">
            <mobileUserNav></mobileUserNav>

            <userInfo></userInfo>

            <div class="col_xl_8 col_l_8 col_m_8 col_s_12">
              <p class="user_title">Profile</p>

              <div class="avatar" v-if="user">
                <img :src="user.photoURL" alt="" v-if="user.photoURL"/>

              </div>

              <div class="avatar_buttons">
                <input
                    type="file"
                    name=""
                    id="user_photo"
                    v-on:change="updateUserPhoto"
                    accept="image/*"
                />
                <label for="user_photo" class="color_btn hover_op"
                >Upload New</label
                >

                <button
                    class="color_btn colored_btn hover_op"
                    @click="removeUserPhoto"
                >
                  Delete
                </button>
              </div>

              <inputWrap
                  :title="'First & last name'"
                  :type="'text'"
                  :placeholder="'Edith Anderson'"
                  :required="true"
                  :inputData.sync="name"
              ></inputWrap>

              <inputWrap
                  :title="'Email address'"
                  :type="'mail'"
                  :placeholder="'edithanderson@gmail.com'"
                  :required="true"
                  :inputData.sync="mail"
              ></inputWrap>

              <router-link to="/user_pass" class="change_pass hover_op"
              >Change password
              </router-link>

              <button
                  class="color_btn hover_op create_room"
                  :class="{ disabled: canUpdate }"
                  @click="updateUserInfo"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </section>
    </main>

    <footerComponent></footerComponent>
  </div>
</template>

<script>
import footerComponent from "@/components/footerComponent.vue";
import inputWrap from "@/components/inputWrap.vue";
import userInfo from "@/components/userInfo.vue";
import mobileUserNav from "@/components/mobileUserNav.vue";
import {
  getAuth,
  updateProfile,
  reload,
  EmailAuthProvider,
  reauthenticateWithCredential,
  verifyBeforeUpdateEmail, GoogleAuthProvider, reauthenticateWithPopup, FacebookAuthProvider, linkWithCredential
} from "firebase/auth";
import apiClient from "../apiClient";
import {uploadFile} from "../FileUploadUtils";

export default {
  name: "User_profile",

  data() {
    return {
      name: "",
      mail: "",
    };
  },

  components: {
    inputWrap,
    userInfo,
    footerComponent,
    mobileUserNav,
  },

  computed: {
    hasEmailPasswordLogin() {
      return this.$store.state.user?.providerData.find(it => it.providerId === "password") != null
    },
    canUpdate() {
      if (
          this.name != this.$store.state.user.displayName ||
          this.mail != this.$store.state.user.email
      ) {
        return false;
      } else {
        return true;
      }
    },

    user() {
      return this.$store.state.user;
    },
  },

  methods: {
    async updateUserInfo() {
      try {
        let name = this.name;
        let mail = this.mail;

        if (mail !== this.user.email) {
          let credential
          let user = getAuth().currentUser

          /*if (this.hasEmailPasswordLogin) {
            console.log("reauthenticateWithCredential")
            const password = prompt("Password") //TODO: Ask for password here
            credential = EmailAuthProvider.credential(user.email, password)
            await reauthenticateWithCredential(user, credential)
          } else {
            let firstProvider = getAuth().currentUser.providerData.find(it => it.providerId !== "password")?.providerId
            console.log("reauthenticateWithCredential", {firstProvider})

            if (firstProvider === GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD) {
              console.log("reauthenticateWithCredential GOOGLE")
              await reauthenticateWithPopup(user, new GoogleAuthProvider())
            } else if (firstProvider === FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD) {
              console.log("reauthenticateWithCredential FACEBOOK")
              await reauthenticateWithPopup(user, new FacebookAuthProvider())
            }
          }*/

          await apiClient.post("/user/send-email-address-change-email", {
            email: mail
          })
          alert("You received a confirmation email. Check your inbox")
          return;
        }

        const user = getAuth().currentUser
        await updateProfile(user, {
          displayName: name
        })

        await reload(user)
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },
    async removeUserPhoto() {
      try {

        const user = getAuth().currentUser

        await apiClient.post("/profile_photo_placeholder").then(response => response.data)

        await reload(user)
        this.$forceUpdate()
      } catch (e) {
        this.$store.dispatch("onError", "Error data loading :(");
        console.error(e);
      }
    },
    async updateUserPhoto(event) {
      try {
        const user = getAuth().currentUser
        const file = event.target.files[0];

        const path = `users/${user.uid}/custom_photo_url`

        const url = await uploadFile(file, path)

        await updateProfile(user, {photoURL: url})
        await reload(user);
        this.$forceUpdate()
      } catch (e) {
        this.$store.dispatch("onError", "Error data loading :(");
        console.error(e);
      }
    },
    async fetchUserInfo() {
      this.name = this.user.displayName;
      this.mail = this.user.email;
    },
  },

  mounted() {
    this.fetchUserInfo();
  },
};
</script>

<style lang="scss" scoped>
#user_photo {
  display: none;

  & + label {
    cursor: pointer;
  }
}

.avatar {
  width: 128px;
  height: 128px;
  font-size: 36px;
  font-weight: 400;
  line-height: 48px;
  margin-bottom: 64px;

  @media all and (max-width: 767px) {
    margin-bottom: 32px;
  }
}

.avatar_buttons {
  display: flex;
  align-items: center;
  margin-bottom: 64px;

  @media all and (max-width: 767px) {
    margin-bottom: 32px;
    flex-wrap: wrap;
  }

  .color_btn {
    margin-right: 16px;
    width: 152px;

    @media all and (max-width: 767px) {
      margin-right: 0;
      width: 100%;
    }
  }

  .colored_btn {
    width: 96px;

    @media all and (max-width: 767px) {
      width: 100%;
      margin-top: 16px;
    }
  }
}

.edit {
  font-family: "Nunito Sans", sans-serif;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 24px;
  text-transform: none;
  z-index: 2;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  position: absolute;
  width: 100%;
  bottom: 20px;

  &.remove {
    bottom: 5px;
  }
}
</style>
